import { render, staticRenderFns } from "./manage-web-form.vue?vue&type=template&id=79f196a4&scoped=true&"
import script from "./manage-web-form.vue?vue&type=script&lang=js&"
export * from "./manage-web-form.vue?vue&type=script&lang=js&"
import style0 from "./manage-web-form.vue?vue&type=style&index=0&lang=css&"
import style1 from "./manage-web-form.vue?vue&type=style&index=1&id=79f196a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f196a4",
  null
  
)

export default component.exports